<template>
  <div>
    <div class="bottom-bar-container">
      <div class="bottom-bar-wrapper">
        <div class="bottom-bar-base"></div>
        <div class="bottom-bar-corner" :style="style1"></div>
        <div class="bottom-bar-left flexBetween" :style="style2">
          <div class="bottom-bar-item" @click="doQuit">
            <img src="../assets/icon_quit.png" class="bottom-bar-icon" />
            <div class="bottom-bar-text">退出</div>
          </div>
          <div v-if="isElectron" class="bottom-bar-item" @click="goMini">
            <img src="../assets/icon_mini.png" class="bottom-bar-icon" />
            <div class="bottom-bar-text">最小化</div>
          </div>
          <div v-if="!isLogin" class="bottom-bar-item" @click="goHome">
            <img src="../assets/icon_home.png" class="bottom-bar-icon" />
            <div class="bottom-bar-text">首页</div>
          </div>
          <div v-if="!isLogin" class="bottom-bar-item" @click="goBack">
            <img src="../assets/icon_bar_back.png" class="bottom-bar-icon" />
            <div class="bottom-bar-text">返回</div>
          </div>
        </div>
        <div class="right-corner" v-if="!isLogin"></div>
        <div class="right-bar " v-if="!isLogin">
          <div
            @click="goWordSearch"
            class="right-bar-item"
            :class="{ active: isSearch }"
          >
            <img src="../assets/bar_search.png" class="right-bar-icon" />
            <div class="bottom-bar-text">搜字教学</div>
          </div>
          <div
            @click="goComment"
            class="right-bar-item"
            :class="{ active: isComment }"
          >
            <img src="../assets/text_comment.png" class="right-bar-icon" />
            <div class="bottom-bar-text">书写点评</div>
          </div>
          <div
            @click="goClassList"
            class="right-bar-item"
            :class="{ active: isClass }"
          >
            <img src="../assets/bar_student.png" class="right-bar-icon" />
            <div class="bottom-bar-text">我的班级</div>
          </div>
          <div
            @click="goResource"
            class="right-bar-item"
            :class="{ active: isResource }"
          >
            <img src="../assets/bar_video.png" class="right-bar-icon" />
            <div class="bottom-bar-text">课件资源</div>
          </div>
        </div>

        <!-- <div v-if="rightBar == 'startClass'" class="right-corner"></div>
        <div v-if="rightBar == 'startClass'" class="right-bar flexCenter">
          <div class="right-bar-item" @click="startClass">
            <img src="../assets/bar_video.png" class="right-bar-icon"/>
            <div class="bottom-bar-text">开始上课</div>
          </div>
        </div>

        <div v-if="rightBar == 'student'" class="right-corner"></div>
        <div v-if="rightBar == 'student'" class="right-bar flexCenter">
          <div class="right-bar-item" @click="$router.back()">
            <img src="../assets/bar_student.png" class="right-bar-icon"/>
            <div class="bottom-bar-text">班级学员</div>
          </div>
        </div> -->
      </div>
    </div>
    <pop-confirm ref="pop-confirm"></pop-confirm>
  </div>
</template>

<script>
import PopConfirm from "./PopConfirm.vue";

export default {
  components: { PopConfirm },
  name: "BottomBar",
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
    rightBar: {
      type: String,
      default: "",
    },
    // msg: String
  },
  computed: {
    isSearch() {
      return this.$route.path.includes("word_search");
    },
    isClass() {
      return this.$route.path.includes("class_list");
    },
    isComment() {
      return this.$route.path.includes("comment");
    },
    isResource() {
      return this.$route.path.includes("start_class");
    },
    style1() {
      if (this.isElectron) {
        return this.isLogin ? "left:10rem;" : "left:15rem;";
      } else {
        return "left:12rem;";
      }
    },
    style2() {
      if (this.isElectron) {
        return this.isLogin ? "width:8rem;" : "width:13rem;";
      } else {
        return "width:10rem;";
      }
    },
    isElectron() {
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf(" electron/") > -1) {
        return true;
      } else return false;
    },
  },
  data() {
    return {
      val: "",
    };
  },
  methods: {
    goWordSearch() {
      this.$router.replace("/word_search");
    },
    goComment() {
      this.$router.replace("/text_comment");
    },
    goClassList() {
      this.$router.replace("/class_list");
    },
    goResource() {
      this.$router.replace("/start_class");
    },
    goBack() {
      this.$router.back();
    },
    minSize() {
      console.log(window.fromWebToElectron);
      // window.fromWebToElectron({type:"minsize"})
    },
    goHome() {
      this.$router.replace("/word_search");
    },
    doQuit() {
      this.$refs["pop-confirm"].show({
        title: "",
        content: "确定要退出么",
        success: () => {
          sessionStorage.removeItem("xiaobi_access_token");
          sessionStorage.removeItem("xiaobi_teacher");
          this.$router.replace("/login");
          window.dispatchEvent(new Event("exitApp"));
        },
        cancle: () => {
          console.log("cancle");
        },
      });
    },
    goMini() {
      window.dispatchEvent(new Event("windowMin"));
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bottom-bar-container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 4.5rem;
}

.bottom-bar-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}

.bottom-bar-base {
  width: 100%;
  height: 2rem;
  background: #0f85db;
  position: absolute;
  bottom: 0;
  left: 0;
}

.bottom-bar-corner {
  width: 4.5rem;
  height: 4.5rem;
  background: #0f85db;
  position: absolute;
  top: 0;
  transform: rotate(45deg);
  transform-origin: left top;
}

.bottom-bar-left {
  height: 4.5rem;
  background: #0f85db;
  padding-left: 2rem;
  position: absolute;
  bottom: 0;
  left: 0;
}

.bottom-bar-item {
  text-align: center;
  cursor: pointer;
}

.bottom-bar-icon {
  width: 1.8rem;
  height: 1.8rem;
}

.bottom-bar-text {
  font-size: 1rem;
  color: #ffffff;
  padding: 0.2rem 0.5rem;
  margin-top: 0.2rem;
}

.right-corner {
  width: 6.5rem;
  height: 6.5rem;
  background: #0f85db;
  position: absolute;
  bottom: 0;
  right: 24rem;
  transform: rotate(45deg);
  transform-origin: left top;
}

.right-bar {
  height: 6.5rem;
  background: #0f85db;
  width: 30.5rem;
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.right-bar-item {
  text-align: center;
  cursor: pointer;
}

.right-bar-item.active .bottom-bar-text {
  height: 1.42rem;
  background: #16a0e9;
  border-radius: 1.48rem 1.48rem 1.48rem 1.48rem;
}

.right-bar-icon {
  width: 3.7rem;
  height: 3.5rem;
}
</style>
